import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { ShootTypeSchema } from "@redotech/redo-model/inventory/image-generation";
import * as z from "zod/v4";

export const startImageOptimization = {
  name: "startImageOptimization" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    productId: productIdFormat.schema.optional(),
    sourceImageUrls: z.array(z.string()).min(1),
    shootType: ShootTypeSchema.optional(),
  }),
  output: z.object({ workflowId: z.string() }),
};
